"use client";
import SeachFormsCampaignListener from "@/components/SeachFormsCampaignListener";
import BottomSheet from "@/components/ui/BottomSheet";
import { cdnCommonPath } from "@/constants/cdnUrls";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import Image from "next/image";
import { useState } from "react";

const LayoutWrapper = ({
  children,
  pnrFormComponent: PnrFormComponent,
  translationNamespace = "common",
}) => {
  const t = useTranslationDetector();
  const [isPnrModalOpen, setIsPnrModalOpen] = useState(false);

  const handlePnrClick = () => {
    setIsPnrModalOpen(true);
  };

  const closePnrModal = () => {
    setIsPnrModalOpen(false);
  };

  // BottomSheet handles mobile gating, animations and body scroll lock internally

  return (
    <div className="flex flex-col gap-4 md:gap-6">
      {/* Ana form */}
      {children}

      <SeachFormsCampaignListener wrapperClassName="" />

      {/* Mobile PNR & Check-In Butonları */}
      {PnrFormComponent && (
        <div className="shadow-small flex items-center justify-center rounded-lg bg-white/90 md:hidden">
          <button
            onClick={handlePnrClick}
            className="inline-flex w-2/3 items-center justify-center gap-4 p-5 text-sm font-medium"
          >
            <Image
              src={`${cdnCommonPath}online-cancel.svg`}
              alt={t(`${translationNamespace}.pnrSearch`)}
              width={40}
              height={40}
              className="!h-10 !w-10"
            />
            <span>{t(`${translationNamespace}.pnrSearch`)}</span>
          </button>
        </div>
      )}
      {/* PNR BottomSheet */}
      {PnrFormComponent && (
        <BottomSheet
          isOpen={isPnrModalOpen}
          onClose={closePnrModal}
          title={t(`${translationNamespace}.pnrSearch`)}
        >
          <PnrFormComponent onClose={closePnrModal} />
        </BottomSheet>
      )}
    </div>
  );
};

export default LayoutWrapper;
